
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
  display:block;
}

figure {
  margin:0px;
  display:flex;
  flex-direction:column;
}

figure.align-center ::slotted(img) {
  margin-left:auto;
  margin-right:auto;
}

figure.align-right ::slotted(img) {
  margin-left:auto;
}

figure.rounded ::slotted(img) {
  border-radius:0.75rem;
}

figure.has-shadow ::slotted(img){
  box-shadow:var(--brand-shadow);
}

figure.full-height {
  height:100%;
}

figure.full-height ::slotted(img) {
  object-fit:cover;
}

figure.full-height ::slotted(img) {
  height:100% !important;
}

::slotted([slot='caption']) {
  margin-top:1.25rem;
  font-family:var(--ff-body);
  font-size:var(--fs-base);
  line-height:var(--lh-base);
  font-style:italic;
  color:var(--neutral-gray);
}

::slotted([slot='srdescription']){
  position:absolute !important;
  width:1px;
  height:1px;
  padding:0;
  margin:-1px;
  overflow:hidden;
  clip:rect(0, 0, 0, 0);
  white-space:nowrap;
  border-width:0;
}

::slotted(img) {
  display:block;
  height:auto;
  width:100%;
}

.default-size ::slotted(img) {
  width:fit-content;
}

.image--slider ::slotted(img) {
  object-fit:cover;
}

.image--slider ::slotted([slot='caption']) {
  margin-left:auto;
  margin-right:auto;
  margin-top:1.5rem;
  max-width:48rem;
  text-align:center;
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  font-style:normal;
}

@media (min-width: 768px){
  .image--slider ::slotted([slot='caption']) {
    margin-top:2rem;
  }
    :host([site='BH']) .image--slider ::slotted([slot='caption']) {
    margin-top:1rem;
  }
}

:host([image-ratio='1/1']) ::slotted(img){
  aspect-ratio:1 / 1;
}

:host([image-ratio='3/2']) ::slotted(img){
  aspect-ratio:3 / 2;
}

:host([image-ratio='3/4']) ::slotted(img){
  aspect-ratio:3 / 4;
}

:host([image-ratio='4/3']) ::slotted(img){
  aspect-ratio:4 / 3;
}

:host([image-ratio='5/4']) ::slotted(img){
  aspect-ratio:5 / 4;
}

:host([image-ratio='16/9']) ::slotted(img){
  aspect-ratio:16 / 9;
}

:host([image-ratio='9/16']) ::slotted(img){
  overflow:hidden;
  display:flex;
  aspect-ratio:9 / 16;
}

:host([image-ratio='21/9']) ::slotted(img){
  aspect-ratio:21 / 9;
}

:host([image-ratio='1/1']) figure.full-height {
  aspect-ratio:1;
}

:host([image-ratio='1/1']) figure.full-height {
  width:auto;
}

@media (min-width: 768px){
    :host([sideways]) figure.sideways {
    aspect-ratio:1;
  }
  }

:host([sideways]) figure.sideways{
    aspect-ratio:inherit;
  }

figcaption.align-left {
  text-align:left;
}

figcaption.align-center {
  text-align:center;
}

figcaption.align-right {
  text-align:right;
}

:host([site='BH']):host([full-height]) {
  height:100%;
}

:host([site='BH']) ::slotted([slot='caption']), :host([site='BH']) .image--slider ::slotted([slot='caption']) {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) ::slotted([slot='caption']), :host([site='BH']) .image--slider ::slotted([slot='caption']) {
  font-size:var(--bh-fs-body-01);
  line-height:var(--bh-lh-body-01);
  letter-spacing:var(--bh-ls-body-01);
}

:host([site='BH']) ::slotted([slot='caption']), :host([site='BH']) .image--slider ::slotted([slot='caption']) {
  color:var(--neutral-gray-1);
}
`;